export type DevicePlatform = "iOS" | "Desktop" | "Android" | "Khác"

export interface UserAgentInfo {
  platform: DevicePlatform
  os: string
  browser: string
  isMobile: boolean
  label: string
}

export function parseUserAgent(ua?: string | null): UserAgentInfo {
  if (!ua) {
    return {
      platform: "Khác",
      os: "Không rõ",
      browser: "Không rõ",
      isMobile: false,
      label: "Không rõ",
    }
  }

  const isMobile = /mobile|android|iphone|ipad|ipod/i.test(ua)
  let platform: DevicePlatform = "Desktop"
  let os = "Khác"
  let browser = "Khác"

  // OS / Platform Detection
  if (/iphone|ipad|ipod/i.test(ua)) {
    platform = "iOS"
    os = "iOS"
  } else if (/android/i.test(ua)) {
    platform = "Android"
    os = "Android"
  } else if (/windows phone/i.test(ua)) {
    platform = "Khác"
    os = "Windows Phone"
  } else if (/win/i.test(ua)) {
    platform = "Desktop"
    os = "Windows"
  } else if (/mac/i.test(ua)) {
    platform = "Desktop"
    os = "macOS"
  } else if (/linux/i.test(ua)) {
    platform = "Desktop"
    os = "Linux"
  } else {
    platform = isMobile ? "Khác" : "Desktop"
  }

  // Browser Detection
  if (/edg/i.test(ua)) browser = "Edge"
  else if (/opr|opera/i.test(ua)) browser = "Opera"
  else if (/chrome|crios/i.test(ua)) browser = "Chrome"
  else if (/firefox|fxios/i.test(ua)) browser = "Firefox"
  else if (/safari/i.test(ua) && !/chrome/i.test(ua)) browser = "Safari"

  const label = platform === "Desktop" ? `Desktop (${os} • ${browser})` : `${platform} • ${browser}`

  return { platform, os, browser, isMobile, label }
}
